import styled from 'styled-components';
import { Search } from '@material-ui/icons';
import { CampaignsStyleProps } from './Campaigns.interface';

export const InputWrapper = styled.div<CampaignsStyleProps>`
    margin: ${({ theme }) => theme.spacing * 30}px auto
        ${({ theme }) => theme.spacing * 10}px;
    width: 940px;
    display: grid;
    grid-template-columns: ${props => props.adminAccess
        ? 'repeat(4, 1fr)'
        : '220px 1fr 1fr'
    };
    grid-column-gap: ${({ theme }) => theme.spacing * 5}px;
    @media screen and (max-width: 690px) {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        grid-template-columns: 100%;
        grid-row-gap: ${({ theme }) => theme.spacing * 5}px;
    }
`;

export const StyledSearchIcon = styled(Search)`
    && {
        color: ${({ theme }) => theme.colors.blue};
        opacity: .37;
    }
`;

export const InfoRow = styled.div<CampaignsStyleProps>`
    width: 940px;
    height: 44px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;;
    box-sizing: border-box;
    display: grid;
    align-items: center;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    grid-template-columns: ${props => props.adminAccess
        ? '95px 156px 220px 115px 90px 92px 30px'
        : '231px 220px 115px 90px 110px 30px'
    };
    > p {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
        opacity: .87;
    }
`;

export const MobileWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${({ theme }) => theme.spacing * 6}px;
    @media screen and (max-width: 600px) {
        grid-template-columns: 100%;
    }
`;
